import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Complaints from "@/pages/Complaints";
import Upload from "@/pages/Upload";
import History from "@/pages/History";
import Sync from "@/pages/Sync";
import Settings from "@/pages/Settings";
import Followups from "@/pages/Followups";
import { Spinner } from "@/components/common";

const Protected = ({ roles, children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex h-screen items-center justify-center"><Spinner className="h-6 w-6 text-slate-400" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><AppProvider><Layout /></AppProvider></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/complaints" element={<Complaints />} />
            <Route path="/followups" element={<Followups />} />
            <Route path="/upload" element={<Protected roles={["admin", "manager"]}><Upload /></Protected>} />
            <Route path="/history" element={<History />} />
            <Route path="/sync" element={<Sync />} />
            <Route path="/settings" element={<Protected roles={["admin"]}><Settings /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors duration={3000} />
    </AuthProvider>
  );
}

export default App;
